export interface PageTrackingParams {
  pageCategory1: string | undefined;
  pageCategory2: string | undefined;
  pageType: string | undefined;
}

export interface PageAnalyticsDetails {
  language: string;
  pageCategory1?: string;
  pageCategory2?: string;
  pageType: "404" | "page" | "post" | "video" | "archive" | "Home Page";
  countryCode?: string;
  market?: string;
}

const getAAMarket = (
  market: string | undefined,
  countryCode: string | undefined
): string | undefined => {
  if (countryCode === "US" || countryCode === "CA") return "US";
  if (market === "FT") return "LAM";
  if (market === "AS") return "AP";
  if (market === "EU") return "EMEA";
  return market;
};

export const sendPageAnalytics = ({
  pageCategory1,
  pageCategory2,
  pageType,
  language,
  countryCode,
  market
}: PageAnalyticsDetails): void => {
  const details = {
    track_current_page: window.location.href.split("?")[0],
    page_cat1: pageCategory1,
    page_cat2: pageCategory2,
    page_type: "blog",
    track_page_type: pageType,
    user_language: language,
    user_country: countryCode,
    user_geo_adwords: getAAMarket(market, countryCode)
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(details);

  window.wspr?.P("pageload_raw", details);
};
